import { APPFACTOR } from "../../components/commons";

const DEFAULT_ORCHESTRATOR_CONFIG_EXISTANCE = {
    config: false,
    store: false
};

const DEFAULT_WS_DATA = {
    wsPort: APPFACTOR.__DEFAULT_PORT,
    wsUrl: APPFACTOR.__DEFAULT_WS_URL
};

export {
    DEFAULT_ORCHESTRATOR_CONFIG_EXISTANCE,
    DEFAULT_WS_DATA
};
